import 'jquery-validation-unobtrusive'

jQuery.validator.unobtrusive.adapters.add('mustbetrue', ['maxint'], function (options) {
    options.rules['mustbetrue'] = options.params
    options.messages['mustbetrue'] = options.message
})

jQuery.validator.addMethod('mustbetrue', function (value, element) {
    return jQuery(element).is(':checked')
})
